import { roomTypes } from '../../../mocks/hotelData';

interface RoomListProps {
  checkInDate: string;
  checkOutDate: string;
  guests: number;
  rooms: number;
}

export default function RoomList({ checkInDate, checkOutDate, guests, rooms }: RoomListProps) {
  return (
    <div className="mb-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">객실 선택</h2>
      
      <div className="space-y-4">
        {roomTypes.map((room) => (
          <div key={room.id} className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow">
            <div className="flex flex-col md:flex-row">
              <div className="md:w-64 h-48 md:h-auto">
                <img 
                  src={room.image} 
                  alt={room.name}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <div className="flex-1 p-5">
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{room.name}</h3>
                    <div className="flex items-center gap-4 text-sm text-gray-600 mb-2">
                      <span className="flex items-center gap-1">
                        <i className="ri-layout-line"></i>
                        {room.size}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-hotel-bed-line"></i>
                        {room.bedType}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-user-line"></i>
                        최대 {room.maxGuests}명
                      </span>
                    </div>
                  </div>
                  
                  {room.discount > 0 && (
                    <div className="bg-red-500 text-white px-2 py-1 rounded text-xs font-bold whitespace-nowrap">
                      {room.discount}% 할인
                    </div>
                  )}
                </div>

                <div className="flex flex-wrap gap-2 mb-4">
                  {room.amenities.map((amenity, index) => (
                    <span key={index} className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                      {amenity}
                    </span>
                  ))}
                </div>

                <div className="flex items-end justify-between">
                  <div>
                    {room.originalPrice > room.price && (
                      <div className="text-sm text-gray-500 line-through mb-1">
                        ₩{room.originalPrice.toLocaleString()}
                      </div>
                    )}
                    <div className="flex items-baseline gap-2">
                      <span className="text-2xl font-bold text-gray-900">
                        ₩{room.price.toLocaleString()}
                      </span>
                      <span className="text-sm text-gray-600">/ 박</span>
                    </div>
                    <p className="text-xs text-gray-500 mt-1">세금 및 수수료 포함</p>
                  </div>

                  <div className="text-right">
                    {room.available > 0 ? (
                      <>
                        <p className="text-xs text-orange-600 font-medium mb-2">
                          {room.available}개 객실만 남음!
                        </p>
                        <button className="bg-teal-600 text-white px-6 py-2 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                          예약하기
                        </button>
                      </>
                    ) : (
                      <button disabled className="bg-gray-300 text-gray-500 px-6 py-2 rounded-lg text-sm font-semibold cursor-not-allowed whitespace-nowrap">
                        예약 마감
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}